import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Radio } from 'antd';
import { theme } from 'utils/style/theme';
import { IDropListProps } from 'utils/types/common';
/**
 * * 기본 라디오 버튼
 */

interface IProps {
  title?: string;
  disabled?: boolean;
  name?: string;
  optionList?: Array<IDropListProps>;
  value?: string | number;
  defaultValue?: string | number;
  onChange?: (e: any) => void;
  style?: React.CSSProperties;
  ref?: React.Ref<HTMLDivElement> | React.Ref<HTMLInputElement> | undefined;
  noMarginBottom?: boolean; // 하단에 더 이상 인풋(컴포넌트)가 없으니, 마진 주지마!
  labelStyle?: React.CSSProperties;
}
const DefaultRadio: React.FC<IProps> = forwardRef(
  (
    {
      title,
      optionList,
      name,
      defaultValue,
      value,
      onChange,
      disabled,
      style,
      labelStyle,
    },
    ref,
  ) => {
    return (
      <Container style={style} title={title}>
        <label className='label_title' style={labelStyle}>
          {title}
        </label>
        <StyleRadio value={defaultValue} name={name} ref={ref}>
          {optionList?.map((v) => (
            <Radio
              key={v.key}
              value={v.value}
              onChange={onChange}
              disabled={disabled}
            >
              {v.text}
            </Radio>
          ))}
        </StyleRadio>
      </Container>
    );
  },
);

export default DefaultRadio;

const Container = styled.div`
  width: 100%;
  display: inline-grid;
  margin-bottom: ${(props) => (props.noMarginBottom ? '0' : '1.2rem')};

  .label_title {
    display: ${(props) => (props.title ? 'block' : 'none')};
  }
  label {
    color: ${theme.colors.blue_7};
    font-size: ${theme.fontSizes.md};
    margin-left: 0.3rem;
    margin-bottom: 0.3rem;
  }
`;
const StyleRadio = styled(Radio.Group)`
  .ant-radio-wrapper-checked > span,
  .ant-radio-wrapper > span,
  .ant-radio-wrapper-in-form-item > span {
    font-size: 0.75rem;
    color: ${theme.colors.dark_500};
  }
  .ant-radio-input {
    width: 2rem;
    height: 2rem;
    /* font-size: 1.2rem; */
  }
`;
